"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEpicMiddlewareFromStore = exports.attachEpicMiddlewareToStore = void 0;
var EPIC_MIDDLEWARE = Symbol('EPIC_MIDDLEWARE');

var attachEpicMiddlewareToStore = function attachEpicMiddlewareToStore(store, epicMiddleware) {
  store[EPIC_MIDDLEWARE] = epicMiddleware;
};

exports.attachEpicMiddlewareToStore = attachEpicMiddlewareToStore;

var getEpicMiddlewareFromStore = function getEpicMiddlewareFromStore(store) {
  return store[EPIC_MIDDLEWARE];
};

exports.getEpicMiddlewareFromStore = getEpicMiddlewareFromStore;